import styled from '@emotion/styled';

export const ContentWrapper = styled('div')`
  position: relative;
  padding-left: 0;
  padding-right: 0;
  padding-top: 19px;

  > div,
  > form > div {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 10px;
  }

  .block-subtitle {
    color: #98a6ad;
    font-size: 11px;
    text-transform: uppercase;
    font-weight: 700;
  }

  .block-anchor {
    position: absolute;
    top: -90px;
  }

  .sub-input {
    font-size: 12px;
    color: #98a6ad;
  }
`;

export const Wrapper = styled(`div`)`
  margin-bottom: 300px;
  @media (max-width: 767px) {
    margin: 0 -22px;

    .menu {
      display: none;
    }

    .settings {
      max-width: 100%;
    }

    .page-title-box {
      padding: 0 24px;
    }

    .card-box {
      width: 100%;
      border-radius: unset;
      box-shadow: none;
    }

    .col-6 {
      flex: 100%;
      max-width: 100%;
    }

    .mail-sending {
    }

    .btn.btn-danger {
      margin-top: 15px;
    }

    .feeds-wrapper {
      padding-top: 0 !important;
    }

    .promocodes-row {
      padding-bottom: 16px;
    }

    .row.justify-content-center {
      padding: 0 24px 24px;
    }
  }
`;
